class ToolTip extends HTMLElement {
  constructor() {
    super();

    this.toolTipTrigger = this.closest('.tooltip');

    this.boundingClient = this.getBoundingClientRect();
    this.initX = this.boundingClient.x;

    this.r = document.querySelector(':root');

    if (this.toolTipTrigger) {
      this.toolTipTrigger.addEventListener('mouseenter', this.positionToolTipEnter.bind(this));
      this.toolTipTrigger.addEventListener('mouseleave', this.positionToolTipLeave.bind(this));
    }
  }

  positionToolTipEnter() {
    const toolTipRect = this.getBoundingClientRect();
    if (this.initX > 0) {
      this.toolTipTrigger.style.setProperty('--tooltip-arrow-visibility', 'visible');
    }

    if (this.initX + toolTipRect.width < window.innerWidth) {
      this.toolTipTrigger.style.setProperty('--tooltip-arrow-visibility', 'visible');
    }
  }

  positionToolTipLeave() {
    this.toolTipTrigger.style.setProperty('--tooltip-arrow-visibility', 'hidden');
  }
}

customElements.define('tool-tip', ToolTip);
